module.exports = __webpack_public_path__ + "assets/img/trade.410528cc.png";